<template>
  <!-- 绑定大区开始 -->
  <c-base-dialog v-model="isShow" :option="dialogOption" @close="$emit('close')">
    <template slot="body">
      <div
          :class="[ 'ceiba-base-role-dialog--default', !isMobile ? 'ceiba-base-role-dialog--pc' : '']"
      >
        <!-- <a href="javascript:;" class="ceiba-base-role-dialog-close" @click="$emit('close')"></a> -->
        <div class="area-choose">
          <div class="checked_wrap">
            <!-- 默认选中，取消加disabled -->
            <span :class="['checked_icon_wrap', check ? '': 'disabled']" @click="checkAuthorize">
              <span class="checked_icon" :style="checkStyle"></span>
            </span>
            我同意授权“本活动获取并存储我的游戏区服信息”
          </div>
          <div class="choose-box choose-items" v-if="mobileGame">
            <div class="area-items" :style="colorStyle">平台</div>
            <a href="javascript:;" v-if="!check" class="area-select not-check" @click="clickCheck">
              <span class="select-mock">请选择平台</span>
            </a>
            <div v-else class="area-select">
              <select @click="fixIOSbug" v-model="device" @change="fetchPartition">
                <option value selected disabled>请选择平台</option>
                <option value="ios">苹果(iOS)</option>
                <option value="android">安卓(android)</option>
              </select>
            </div>
          </div>
          <div class="choose-box choose-items">
            <div class="area-items" :style="colorStyle">服务器</div>
            <a href="javascript:;" v-if="!check" class="area-select not-check" @click="clickCheck">
              <span class="select-mock">请选择服务器</span>
            </a>
            <div v-else class="area-select">
              <select
                  @click="fixIOSbug"
                  v-model="selectedPartitionName"
                  @change="refreshRoleList($event.target.value)"
              >
                <option value selected disabled>请选择服务器</option>
                <option
                    :value="partition.name"
                    v-for="(partition, index) in partitionList"
                    :key="index"
                >{{ partition.name | base64decode }}</option>
              </select>
            </div>
          </div>
          <div class="choose-box choose-items">
            <div class="area-items" :style="colorStyle">角色</div>
            <a href="javascript:;" v-if="!check" class="area-select not-check" @click="clickCheck">
              <span class="select-mock">请选择角色</span>
            </a>
            <div v-else class="area-select">
              <select @click="fixIOSbug" v-model="selectedRoleId">
                <option value selected disabled>请选择角色</option>
                <option
                    :value="role.role_id"
                    v-for="role in roleList"
                    :key="role.role_id"
                >{{ role.role_name | base64decode }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="ceiba-base-role-modal-footer" :style="footerStyle">
          <a
              :style="confirmStyle"
              href="javascript:;"
              class="btn-ok"
              @click="confirm"
          >{{confirmText}}</a>
        </div>
        <div v-show="showUnbind">
          <a :style="unbindStyle" href="javascript:;" @click="unbindRole">解除绑定</a>
        </div>
      </div>
    </template>
  </c-base-dialog>
  <!-- 绑定大区结束 -->
</template>

<script>
import { Partition, Role, User, Game } from '../apis';
import common from '../../common';
import CDialog from '../base-dialog';

function getAccountType() {
  if (common.tool.getCookie('acctype') === 'wx') {
    return 'wx';
  }
  return 'qq';
}

export default {
  name: 'game-role-select',
  components: {
    [CDialog.name]: CDialog,
  },
  props: {
    game_code: String,
    options: {
      type: Object,
      default: () => ({
        defaultPartitionId: '',
        defaultRoleId: '',
        defaultPartitionName: '',
      }),
    },
    option: {
      type: Object,
      default: () => ({
        dialogStyle: {},
        confirmStyle: {},
        cancelStyle: {},
        closeStyle: {},
      }),
    },
  },
  data() {
    return {
      selectedRoleId: '',
      selectedPartitionId: '',
      selectedPartitionName: '',
      partitionList: [],
      roleList: [],
      device: '',
      check: false,
      isShow: false,
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      showUnbind: false,
    };
  },
  filters: {
    base64decode(value) {
      return common.tool.Base64.decode(value);
    },
  },
  computed: {
    footerStyle() {
      return {
        borderTop: this.option?.confirmStyle?.backgroundImage
          ? ''
          : `1px solid ${
            this.option?.dialogStyle?.color && this.option?.dialogStyle?.backgroundImage
              ? this.option?.dialogStyle?.color
              : 'rgb(221,184,106,0.2)'
          }`,
      };
    },
    borderTopStyle() {
      return this.isMobile ? `0.1rem solid ${this.color}` : `8px solid ${this.color}`;
    },
    checkStyle() {
      return {
        background: this.color,
      };
    },
    colorStyle() {
      return {
        color: this.color,
      };
    },
    confirmText() {
      return this.option?.confirmStyle?.backgroundImage ? '' : '确认';
    },
    confirmStyle() {
      return {
        height: this.isMobile ? '0.7rem' : '42px',
        lineHeight: this.isMobile ? '0.7rem' : '42px',
        margin: this.isMobile ? '0.1rem auto' : '10px auto',
        minWidth: this.isMobile ? '2.2rem' : '120px',
        maxWidth: this.isMobile ? '2.6rem' : '160px',
        fontSize: this.isMobile ? '0.34rem' : '22px',
        color: this.color,
        ...this.option?.confirmStyle,
      };
    },
    unbindStyle() {
      return {
        marginTop: this.isMobile ? '0.2rem' : '4px',
        minWidth: this.isMobile ? '2.2rem' : '120px',
        maxWidth: this.isMobile ? '2.6rem' : '160px',
        fontSize: this.isMobile ? '0.22rem' : '14px',
        color: this.color,
        textDecoration: 'underline',
      };
    },
    color() {
      return this.option?.dialogStyle?.color && this.option?.dialogStyle?.backgroundImage
        ? this.option?.dialogStyle?.color
        : '#ddb86a';
    },
    dialogOption() {
      const dialogOption = Object.assign({}, this.option, {
        height: this.isMobile ? '6.1rem' : '340px',
        width: this.isMobile ? '6.8rem' : '480px',
        fotter: false,
        header: false,
        maskClickable: false,
        dialogStyle: Object.assign({}, this.option?.dialogStyle || {}, {
          color: this.color,
          borderTop: this.option?.dialogStyle?.backgroundImage ? '' : this.borderTopStyle,
        }),
      });
      console.log('dialogOption=', dialogOption);
      return dialogOption;
    },
    mobileGame() {
      return this.$actInfo.game_type !== 1;
    },
  },
  methods: {
    async unbindRole() {
      const currentRole = this.roleList.find(role => role.role_id === this.selectedRoleId);
      await Game.unBindRole(
        {
          game_code: this.game_code,
          device: this.device,
          role: {
            ...currentRole,
          },
        },
        `${this.$actInfo.ast}_act_${this.$actInfo.activity_id}`,
      );
      this.showUnbind = false;
      this.selectedRoleId = '';
    },
    async checkAuthorize() {
      const response = await User.activityAuthorize({
        business: this.$actInfo.ast,
        activity: `${this.$actInfo.activity_id}`,
        status: this.check ? 0 : 1,
      });
      if (response.ret === 0) {
        this.check = !this.check;
      }
    },

    confirm() {
      if (!this.check) {
        this.alert('请授权协议');
        return;
      }
      if (!this.selectedRoleId) {
        this.$toast('请选择角色');
        return;
      }

      this.$emit(
        'finish',
        this.roleList.find(role => role.role_id === this.selectedRoleId),
      );
    },
    async fetchPartition() {
      this.selectedPartitionId = '';
      this.selectedPartitionName = '';
      this.selectedRoleId = '';
      this.roleList = [];
      this.partitionList = await Partition.fetch({
        game_code: this.game_code,
        device: this.device,
        area: getAccountType(),
      });
    },
    async clickCheck() {
      console.log('clickCheck');
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      if (!this.check) {
        this.alert('请授权协议');
        return;
      }
    },

    async refreshRoleList(partitionName) {
      this.roleList = [];
      const partitionInfo = this.partitionList.find(item => item.name === partitionName);
      const { id: partitionId  = '' }  =   partitionInfo || {};
      this.selectedRoleId = '';
      this.roleList = await Role.fetch({
        game_code: this.game_code,
        partition_id: +partitionId,
        device: this.device,
      });
    },
    fixIOSbug() {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
  },
  async mounted() {
    // const { platform } = this.$refs;
    // platform.addEventListener('click', this.clickCheck);
    this.isShow = true;
    const response = await User.getActivityAuthorize({
      business: this.$actInfo.ast,
      activity: `${this.$actInfo.activity_id}`,
    });
    console.log('getActivityAuthorize=', response);
    if (response.ret !== 0) {
      this.alert('获取授权信息失败');
      return;
    }

    if (response.data.status === 1) {
      this.check = true;
    } else {
      this.check = false;
    }

    this.device = common.platform.isIos ? 'ios' : 'android';

    if (this.check) {
      const { defaultRoleId, defaultPartitionId, selectedPartitionName = '' } = this.options;
      if (defaultRoleId && defaultPartitionId) {
        await this.fetchPartition();
        this.selectedPartitionId = defaultPartitionId;
        if (selectedPartitionName)  {
          this.selectedPartitionName = selectedPartitionName;
        } else {
          const  { name = '' } = this.partitionList.find(item => item.id === defaultPartitionId) || {};
          this.selectedPartitionName = name;
        }
        await this.refreshRoleList(this.selectedPartitionName);
        this.selectedRoleId = defaultRoleId;
        if (this.selectedPartitionId && this.selectedRoleId) this.showUnbind = true;
        return;
      }
    }
    await this.fetchPartition();
  },
};
</script>

<style scoped>
@import './index.css';
</style>
